import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';

import Button from '@ts-core/components/Button';
import Dialog, { useDialog } from '@ts-core/components/Dialog';

import GroupSelector, { useGroupSelector } from 'modules/groups/components/GroupSelector';

import LessonsTable from '../../components/LessonsTable';
import { useLessons } from '../../hooks';

import Attendance from './Attendance';

const useStyles = makeStyles((theme) => ({
  groupSelector: {
    marginRight: theme.spacing(4),
    width: 200,
  },
}));

const AttendanceManagementPage = () => {
  const { courseId } = useParams();
  const classes = useStyles();

  const { props: groupSelectorProps, selectedGroup } = useGroupSelector({
    courseId,
  });

  const { onCloseDialog, onOpenDialog, dialogProps } = useDialog();

  const { lessons, loading, error, onDeleteLesson } = useLessons({
    courseId,
    groupId: selectedGroup?._id,
  });

  const handleManageAttendance = useCallback(() => {
    onOpenDialog({
      title: <FormattedMessage id="attendanceManagement.button.controlAttendance" />,
    });
  }, [onOpenDialog]);

  const handleEditLesson = useCallback(
    (lesson) => {
      onOpenDialog({
        title: lesson.name,
        dialogData: {
          lessonId: lesson._id,
        },
      });
    },
    [onOpenDialog]
  );

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" my={2}>
        <GroupSelector {...groupSelectorProps} className={classes.groupSelector} />
        <Box display="flex" alignItems="flex-end">
          <Button variant="contained" color="primary" onClick={handleManageAttendance}>
            <FormattedMessage id="attendanceManagement.button.controlAttendance" />
          </Button>
        </Box>
      </Box>
      <Dialog {...dialogProps}>
        {(data) => <Attendance courseId={courseId} groupId={selectedGroup?._id} onCompletion={onCloseDialog} lessonId={data?.lessonId} />}
      </Dialog>
      <LessonsTable lessons={lessons} loading={loading} error={error} onDeleteLesson={onDeleteLesson} onEditLesson={handleEditLesson} />
    </Box>
  );
};

export default AttendanceManagementPage;
